/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RoleTemplateSelector_organization$ref: FragmentReference;
declare export opaque type RoleTemplateSelector_organization$fragmentType: RoleTemplateSelector_organization$ref;
export type RoleTemplateSelector_organization = {|
  +onRestrictedPlan: boolean,
  +roleTemplates: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +databaseId: string,
        +name: string,
        +purpose: ?string,
        +domains: ?$ReadOnlyArray<string>,
        +accountabilities: ?$ReadOnlyArray<string>,
      |}
    |}>
  |},
  +$refType: RoleTemplateSelector_organization$ref,
|};
export type RoleTemplateSelector_organization$data = RoleTemplateSelector_organization;
export type RoleTemplateSelector_organization$key = {
  +$data?: RoleTemplateSelector_organization$data,
  +$fragmentRefs: RoleTemplateSelector_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleTemplateSelector_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "RoleTemplateConnection",
      "kind": "LinkedField",
      "name": "roleTemplates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "databaseId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "purpose",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "domains",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "accountabilities",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roleTemplates(first:100)"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '6831b556de710df6946824c05f045032';

module.exports = node;
